
import { getCertificates } from 'store/certificates/actions'
import type { Certificates, GetCertificatesPayload } from 'store/certificates/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'


type UseCertificatesParams = GetCertificatesPayload

type UseCertificatesResult = {
  data: Certificates | null
} & UseQuerySelectResult<UseCertificatesParams>

export const useCertificates = (
  params?: UseCertificatesParams,
  options?: UseQuerySelectOptions
): UseCertificatesResult => {
  const result = useQuerySelect(getCertificates, params, options)

  const data = useSelector(state => state.certificates.certificates)

  return {
    data,
    ...result,
  }
}
